import { axios, authAxios } from '@nsd/fe';
import { applyMiddleware, compose, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { createLogger } from 'redux-logger';
import thunkMiddleware from 'redux-thunk';
import rootReducer from 'src/reducers';
import { getClientCompanyCode } from 'src/utils/clientUtils';

// Fix for axios 0.31.1 breaking change: nested objects in params are now
// serialized with bracket notation (e.g. pagination[limit]=25) instead of
// as a single param. The backend expects nested objects as JSON strings.
// Arrays still need bracket notation (e.g. services[]=Fuel&services[]=Jump).
axios.defaults.paramsSerializer = (params) => {
  const parts = [];
  Object.entries(params).forEach(([key, value]) => {
    if (value === null || value === undefined) return;
    if (Array.isArray(value)) {
      value.forEach((item) => {
        parts.push(`${encodeURIComponent(key)}[]=${encodeURIComponent(item)}`);
      });
    } else if (typeof value === 'object') {
      parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(JSON.stringify(value))}`);
    } else {
      parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    }
  });
  return parts.join('&');
};

const ENABLE_REDUX_LOGGER = false;
const loggerMiddleware = createLogger();

// // Add axios middleware. Used to add agent code header
const axiosMiddleware = () => {
  return next => action => {
    const companyCode = getClientCompanyCode();

    axios.defaults.headers.common['Company-Code'] = companyCode;
    axios.defaults.headers.common['Host-Site'] = companyCode;
    authAxios.defaults.headers.common['Company-Code'] = companyCode;
    authAxios.defaults.headers.common['Host-Site'] = companyCode;


    return next(action);
  };
};

export function configureStore(preloadedState = {}) {
  const middlewares = [thunkMiddleware, axiosMiddleware];

  if (ENABLE_REDUX_LOGGER) {
    middlewares.push(loggerMiddleware);
  }

  const middlewareEnhancer = composeWithDevTools(
    applyMiddleware(...middlewares)
  );

  const enhancers = [middlewareEnhancer];
  const composedEnhancers = compose(...enhancers);

  return createStore(rootReducer, preloadedState, composedEnhancers);
}

export const store = configureStore();
